import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/authcontext';
import Login from './pages/login';
import GuestDashboard from './pages/guest/guestdashboard';
import AdminDashboard from './pages/admin/admindashboard';
import StayOverview from './pages/admin/stay-overview';
import FrontOfficeOperations from './pages/admin/front-office-operations';
import FrontOfficeAvailability from './pages/admin/front-office-availability';
import AvailabilityForecast from './pages/admin/availability-forecast';
import FrontOfficeBilling from './pages/admin/front-office-billing';
import BillingReports from './pages/admin/billing-reports';
import FrontOfficeViews from './pages/admin/front-office-views';
import FrontOfficeReports from './pages/admin/front-office-reports';
import FrontOfficeSetup from './pages/admin/front-office-setup';
import FrontOfficeSettings from './pages/admin/front-office-settings';
import HouseKeepingOperations from './pages/admin/house-keeping-operations';
import HouseKeepingSetup from './pages/admin/house-keeping-setup';
import HouseKeepingSettings from './pages/admin/house-keeping-settings';
import PosDashboard from './pages/admin/pos-dashboard';
import PosMain from './pages/admin/pos-main';
import PosOperations from './pages/admin/pos-operations';
import PosSetup from './pages/admin/pos-setup';
import BanquetOperations from './pages/admin/banquet-operations';
import BanquetReports from './pages/admin/banquet-reports';
import BanquetSetup from './pages/admin/banquet-setup';
import StoresOperations from './pages/admin/stores-operations';
import StoresReports from './pages/admin/stores-reports';
import StoresSetup from './pages/admin/stores-setup';
import AccountsOperations from './pages/admin/accounts-operations';
import AccountsReports from './pages/admin/accounts-reports';
import AccountsSetup from './pages/admin/accounts-setup';
import ProfitLoss from './pages/admin/ProfitLoss';
import ChannelManagerOperations from './pages/admin/channel-manager-operations';
import ChannelManagerSettings from './pages/admin/channel-manager-settings';
import SetupSystem from './pages/admin/setup-system';
import SetupCommunication from './pages/admin/setup-communication';
import AdministrationSystem from './pages/admin/administration-system';
import AdministrationIntegrations from './pages/admin/administration-integrations';
import KitchenOperations from './pages/admin/kitchen-operations';
import KitchenMenu from './pages/admin/kitchen-menu';
import KitchenInventory from './pages/admin/kitchen-inventory';
import KitchenReports from './pages/admin/kitchen-reports';
import KitchenSetup from './pages/admin/kitchen-setup';
import BarOperations from './pages/admin/bar-operations';
import BarInventory from './pages/admin/bar-inventory';
import BarMenu from './pages/admin/bar-menu';
import BarMain from './pages/admin/bar-main';
import BarReports from './pages/admin/bar-reports';
import BarSetup from './pages/admin/bar-setup';
import GuestReservationCard from './pages/admin/guest-reservation-card';
import GuestBills from './pages/admin/guest-bills';
import GuestRefund from './pages/admin/guest-refund';
import DaySettlementReport from './pages/admin/day-settlement-report';
import MonthlySalesReport from './pages/admin/monthly-sales-report';
import NightAudit from './pages/admin/night-audit';
import Reservations from './pages/admin/reservations';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />

          {/* Admin Routes */}
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/stay-overview" element={<StayOverview />} />
          <Route path="/admin/front-office/operations" element={<FrontOfficeOperations />} />
          <Route path="/admin/front-office/availability" element={<FrontOfficeAvailability />} />
          <Route path="/admin/availability-forecast" element={<AvailabilityForecast />} />
          <Route path="/admin/front-office/billing" element={<FrontOfficeBilling />} />
          <Route path="/admin/billing-reports" element={<BillingReports />} />
          <Route path="/admin/front-office/views" element={<FrontOfficeViews />} />
          <Route path="/admin/front-office/reports" element={<FrontOfficeReports />} />
          <Route path="/admin/front-office/setup" element={<FrontOfficeSetup />} />
          <Route path="/admin/front-office/settings" element={<FrontOfficeSettings />} />
          <Route path="/admin/house-keeping/operations" element={<HouseKeepingOperations />} />
          <Route path="/admin/house-keeping/setup" element={<HouseKeepingSetup />} />
          <Route path="/admin/house-keeping/settings" element={<HouseKeepingSettings />} />
          <Route path="/admin/pos/dashboard" element={<PosDashboard />} />
          <Route path="/admin/pos/main" element={<PosMain />} />
          <Route path="/admin/pos/operations" element={<PosOperations />} />
          <Route path="/admin/pos/setup" element={<PosSetup />} />
          <Route path="/admin/banquet/operations" element={<BanquetOperations />} />
          <Route path="/admin/banquet/reports" element={<BanquetReports />} />
          <Route path="/admin/banquet/setup" element={<BanquetSetup />} />
          <Route path="/admin/stores/operations" element={<StoresOperations />} />
          <Route path="/admin/stores/reports" element={<StoresReports />} />
          <Route path="/admin/stores/setup" element={<StoresSetup />} />
          <Route path="/admin/accounts/operations" element={<AccountsOperations />} />
          <Route path="/admin/accounts/reports" element={<AccountsReports />} />
          <Route path="/admin/profit-loss" element={<ProfitLoss />} />
          <Route path="/admin/accounts/setup" element={<AccountsSetup />} />
          <Route path="/admin/channel-manager/operations" element={<ChannelManagerOperations />} />
          <Route path="/admin/channel-manager/settings" element={<ChannelManagerSettings />} />
          <Route path="/admin/setup/system" element={<SetupSystem />} />
          <Route path="/admin/setup/communication" element={<SetupCommunication />} />
          <Route path="/admin/administration/system" element={<AdministrationSystem />} />
          <Route path="/admin/administration/integrations" element={<AdministrationIntegrations />} />
          <Route path="/admin/kitchen/operations" element={<KitchenOperations />} />
          <Route path="/admin/kitchen/menu" element={<KitchenMenu />} />
          <Route path="/admin/kitchen/inventory" element={<KitchenInventory />} />
          <Route path="/admin/kitchen/reports" element={<KitchenReports />} />
          <Route path="/admin/kitchen/setup" element={<KitchenSetup />} />
          <Route path="/admin/bar/main" element={<BarMain />} />
          <Route path="/admin/bar/operations" element={<BarOperations />} />
          <Route path="/admin/bar/inventory" element={<BarInventory />} />
          <Route path="/admin/bar/menu" element={<BarMenu />} />
          <Route path="/admin/bar/reports" element={<BarReports />} />
          <Route path="/admin/bar/setup" element={<BarSetup />} />

          {/* Guest & Reports Routes */}
          <Route path="/admin/guest-card/:bookingId" element={<GuestReservationCard />} />
          <Route path="/admin/guest-bills/:bookingId" element={<GuestBills />} />
          <Route path="/admin/guest-refund/:bookingId" element={<GuestRefund />} />
          <Route path="/admin/day-settlement" element={<DaySettlementReport />} />
          <Route path="/admin/monthly-sales" element={<MonthlySalesReport />} />
          <Route path="/admin/night-audit" element={<NightAudit />} />
          <Route path="/admin/reservations" element={<Reservations />} />

          {/* Guest Route */}
          <Route path="/guest" element={<GuestDashboard />} />

          {/* Redirect unknown routes to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;